import {Order, OrderDetail} from "../../../../types/orders/order";

export interface OrderIdentifier {
    organizationCode: string;
    originOrderId: string;
    originSystemCode: string;
    orderDate: string;
}

export interface StateUpdateDto {
    error: string,
    notUpdated: number
}

export interface OrderItemIdentifier {
    organizationCode: string;
    originOrderId: string;
    originSystemCode: string;
    orderDate: string;
    articleId: string;
}


export const orderToOrderIdentifier = (order: Order): OrderIdentifier => {
    return {
        organizationCode: order.organizationCode,
        originOrderId: order.originOrderId,
        originSystemCode: order.originSystemCode,
        orderDate: order.orderDate
    }
};

export const orderToOrderItemIdentifier = (orderItem:OrderDetail, order: Order): OrderItemIdentifier => {
    return {
        organizationCode: order.organizationCode,
        originOrderId: order.originOrderId,
        originSystemCode: order.originSystemCode,
        orderDate: order.orderDate,
        articleId: orderItem.articleId
    }
};